export default {
  id: null,
  nome: null,
  tipo: null,
  tituloEmail: null,
  template: null,
  urlRedirecionamento: null,
  boardColumnId: null,
  origemId: null,
  finalidade: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/campanhamodelomodel.js